import {Fetch} from "water-rest/src/fetch/Fetch";
import {FiasSearchResult} from "water-rest/src/model/fias/SearchResult";
import {DadataResponse} from "water-rest/src/model/dadata/DadataResponse";
import {DadataSuggestion} from "water-rest/src/model/dadata/DadataSuggestion";
import store from "@/store";
import {ISettings} from "@/model/settings/MapSettings";
import {warningToast} from "water-layout/src/services/toastr-service";
import {GeocodeResult, DadataAddressInfo} from "water-rest/src/model/dadata/DadataAddressInfo";

export const searchByFiasAddressDD = (address: FiasSearchResult): Promise<Array<number>> => {
  if (address == null || address.address == null) return Promise.reject();
  return new Promise<Array<number>>((resolve, reject) => {
    const settings: ISettings | null = store.getters.settings;
    if ( !settings || !settings.daDataApiKey ) {
      // if ( process.env.NODE_ENV === 'production' )
        warningToast('Работа с DaData невозможна по причине отсутствия api-ключа');
      return reject();
    }
    Fetch.postJson<DadataResponse>(
      `https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address`,
      { query: address.address },
      { Authorization: `Token ${settings.daDataApiKey}` },
      true,
    )
      .then((response: DadataResponse) => {
        if (response.suggestions.length === 0) return reject();

        const firstObject: DadataSuggestion | undefined = response.suggestions.find( s => s.data.fias_id === address.id);
        if ( !firstObject || !firstObject.data.geo_lat || !firstObject.data.geo_lon ) return reject();

        resolve([parseFloat(firstObject.data.geo_lat), parseFloat(firstObject.data.geo_lon)]);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const searchByFiasAddressIdDD = (address: FiasSearchResult): Promise<Array<number>> => {
  if (address == null || address.id == null) return Promise.reject();
  return new Promise<Array<number>>((resolve, reject) => {
    const settings: ISettings | null = store.getters.settings;
    if (!settings || !settings.daDataApiKey) {
      // if ( process.env.NODE_ENV === 'production' )
      warningToast('Работа с DaData невозможна по причине отсутствия api-ключа');
      return reject();
    }
    Fetch.postJson<DadataResponse>(
      `https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/address`,
      { query: address.id },
      { Authorization: `Token ${settings.daDataApiKey}` },
      true,
    )
      .then((response: DadataResponse) => {
        if (response.suggestions.length === 0) return reject();

        const firstObject: DadataSuggestion | undefined = response.suggestions.find( s => s.data.fias_id === address.id);
        if ( !firstObject || !firstObject.data.geo_lat || !firstObject.data.geo_lon ) return reject();

        resolve([parseFloat(firstObject.data.geo_lat), parseFloat(firstObject.data.geo_lon)]);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const searchAddressByCoordsDD = (coords: Array<number>): Promise<DadataResponse> => {
  return new Promise<any>((resolve, reject) => {
    if (coords && coords.length) {
      const settings: ISettings | null = store.getters.settings;
      if ( !settings || !settings.daDataApiKey ) {
        if ( process.env.NODE_ENV === 'production' )
          warningToast('Работа с DaData невозможна по причине отсутствия api-ключа');
        return reject();
      }
      Fetch.postJson<DadataResponse>(
        `https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address`,
        { lat: coords[0], lon: coords[1] },
        { Authorization: `Token ${settings.daDataApiKey}` },
        true
      )
        .then((response: DadataResponse) => {
          if (response.suggestions.length === 0) return reject();

          resolve(response);
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject()
    }
  })
};

export const searchByDataAddressInfo = (address: string, regionIds?: number[], regionFiasCodes?: string[], localityFiasCode?: string[], size = 10): Promise<DadataAddressInfo[]> => {
    if (address === null) return Promise.reject();

    return new Promise<any>((resolve, reject) => {
        const regionIdsQuery = regionIds && regionIds.length > 0 ? `&regionIds=${regionIds}` : '';
        const regionFiasCodesQuery = regionFiasCodes && regionFiasCodes.length > 0 ? `&regionFiasCodes=${regionFiasCodes}` : '';
        const localityFiasCodeQuery = localityFiasCode && localityFiasCode.length > 0 ? `&localityFiasCode=${localityFiasCode}` : '';

        Fetch.getJson<DadataAddressInfo[]>(`${Fetch.buildFiasModuleUrl()}/mapSearch/daDataAddressInfo?fullTextSearch=${address}&size=${size}${regionIdsQuery}${regionFiasCodesQuery}${localityFiasCodeQuery}`)
            .then((result: DadataAddressInfo[]) => {
                if (result.length === 0) return reject();
                resolve(result);
            }).catch((error) => {
            reject(error);
        });
    });
}

export const geocodeByIdDadata = (id: string): Promise<GeocodeResult> => {
    if (id === null) return Promise.reject();

    return new Promise<any>((resolve, reject) => {
        Fetch.getJson<GeocodeResult[]>(`${Fetch.buildFiasModuleUrl()}/mapSearch/daDataCoordinatesById?fiasId=${id}`)
            .then((result: GeocodeResult[]) => {
                if (result.length === 0) return reject();
                resolve(result);
            }).catch((error) => {
            reject(error);
        });
    });
};

export const geocodeByAddressDadata = (address: string): Promise<GeocodeResult> => {
    if (address === null) return Promise.reject();

    return new Promise<any>((resolve, reject) => {
        Fetch.getJson<GeocodeResult>(`${Fetch.buildFiasModuleUrl()}/mapSearch/daDataCoordinatesByAddress?query=${address}`)
            .then((result: GeocodeResult) => {
                if (!result.latitude && !result.longitude) return reject();
                resolve(result);
            }).catch((error) => {
            reject(error);
        });
    });
};

export const geocodeByAddressYandex = (address: string): Promise<GeocodeResult> => {
    if (address === null) return Promise.reject();

    return new Promise<any>((resolve, reject) => {
        Fetch.getJson<GeocodeResult>(`${Fetch.buildFiasModuleUrl()}/mapSearch/yandexCoordinatesByAddress?query=${address}`)
        .then((result: GeocodeResult) => {
            if (!result.latitude && !result.longitude) return reject();
            resolve(result);
        }).catch((error) => {
            reject(error);
        });
    });
};

